package io.github.jangalinski.pages._2014._09._19

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initCloneAllGithubReposOfAnOrganizationPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("2014/09/19/CloneAllGithubReposOfAnOrganization.md", FrontMatterElement.Builder { addScalar("title", "Clone all github repos of an organization"); addScalar("subtitle", "sometimes you need just everything at once"); addScalar("date", "2014-09-19"); }))
}

@Page("/2014/09/19/clone-all-github-repos-of-an-organization")
@Layout(".site.components.layout.BlogLayout")
@Composable
fun CloneAllGithubReposOfAnOrganizationPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("clone-all-repos-of-an-organization") }) {
        org.jetbrains.compose.web.dom.Text("Clone all repos of an organization")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("During the live coding session of Nico, I needed to get all content of ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/bpmn-io") {
            org.jetbrains.compose.web.dom.Text("bpmn.io")
        }
        org.jetbrains.compose.web.dom.Text(". Instead of cloning every repository on its own, I used this ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://gist.github.com/caniszczyk/3856584") {
            org.jetbrains.compose.web.dom.Text("gist")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("And because it is such a nice feature, I wrapped it in a function:")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""function git.github.clone.organization() {
    if [ ${'$'}# -ne 0 ]
    then
        mkdir ${'$'}1
        cd ${'$'}1
        curl -s https://api.github.com/orgs/${'$'}1/repos?per_page=200 | ruby -rubygems -e 'require "json"; JSON.load(STDIN.read).each { |repo| %x[git clone #{repo["ssh_url"]} ]}'
    else
        echo "git.github.clone.organization <organization>"
    fi
}
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Thanks, ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/caniszczyk") {
            org.jetbrains.compose.web.dom.Text("caniszczyk")
        }
        org.jetbrains.compose.web.dom.Text("!")
    }
}
